import "bootstrap/dist/css/bootstrap.min.css";
import "./src/static/lib/font-awesome/css/font-awesome.min.css"
import "./src/static/lib/animate/animate.min.css"
import "./src/static/lib/font-awesome/css/font-awesome.css"
import "./src/static/lib/ionicons/css/ionicons.min.css"
import "./src/static/lib/owlcarousel/assets/owl.carousel.min.css"
import "./src/static/css/button.css";

// import "bootstrap/dist/js/bootstrap.min.js";
// import "@popperjs/core/dist/umd/popper.min.js";
// import "jquery/dist/jquery.min.js"
import "./src/static/js/Poppins-Black.ttf"

import './src/static/css/videoReviewCard.css'
import './src/static/css/offerBanner.css'
import './src/static/css/languageLanding.css'
import './src/static/css/whatsappFloat.css'
import './src/static/css/jlptVideos.css'
import './src/static/css/japanLanding.css'
import './src/static/css/style.css'

import React from "react";
import WhatsAppFloat from "./src/component/WhatsAppFloat/WhatsAppFloat";

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <WhatsAppFloat />
  </>
);